<template>
    <div style="overflow-y: auto">
        <div ref="modal" class="modal fade" :id="id" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div v-if="user" class="modal-content">
                    <div class="modal-header">
                        <div>
                            <h5 class="modal-title">User Detail</h5>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="user.loading" class="modal-body" style="min-height: 300px">
                        <Loader :min-height="'100%'"></Loader>
                    </div>
                    <div v-else class="modal-body">
                        <div class="d-flex justify-content-end align-items-center mb-4">
                            <span class="icon-image-border">
                                <UserIcon v-if="!user.image_profile" size="2.25x" class="custom-class" />
                                <img v-else :src="user.image_profile" width="100%" height="100%" alt="user image" />
                            </span>
                            <span class="d-block pl-2" style="min-width: 100px">
                                <div>{{ user.name }}</div>
                                <div style="font-size: 14px">{{ user.role_label }}</div>
                            </span>
                        </div>
                        <div v-if="detailBoards" class="detail-board d-flex flex-column mb-4">
                            <div class="d-flex align-items-center">
                                <div v-for="(detail, index) in detailBoards.details.filter(detail => detail.condition)" :key="index" class="board-item flex-1">
                                    <div class="item-wrapper text-center">
                                        <div style="font-size: 20px">{{ detail.value }}</div>
                                        <div class="text-nowrap">{{ detail.title }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div v-for="(order, index) in detailBoards.orders.filter(order => order.condition)" :key="index" class="board-item flex-1">
                                    <div class="item-wrapper text-center">
                                        <div style="font-size: 20px">{{ order.value }}</div>
                                        <div class="text-nowrap">{{ order.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-4">
                                Email :&nbsp;
                                <span>{{ user.email }}</span>
                            </div>
                            <div class="col-md-6 mb-4">
                                Recruited User :&nbsp;
                                <span>{{ user.suggested_users ? user.suggested_users.length : 0 }}</span>
                            </div>
                            <div class="col-md-12 font-weight-bold">
                                <span>Register information</span>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="row">
                                    <div class="col-md-6">Register first time :</div>
                                    <div class="col-md-6">
                                        <span>{{ user.register_time }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">Last visit :</div>
                                    <div class="col-md-6">
                                        <span>{{ user.last_visit ? user.last_visit_readable : '-' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="row">
                                    <div class="col-md-6">Country :</div>
                                    <div class="col-md-6">
                                        <span v-if="user.country">
                                            <img
                                                :src="`https://flagcdn.com/64x48/${user.country.code.toLowerCase()}.png`"
                                                alt="flag"
                                                width="25px"
                                            />&nbsp;
                                            {{ user.country.name || '' }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">Referrer :</div>
                                    <div class="col-md-6">
                                        <p v-html="displayReferrer(user.referrer_register)" style="word-break: break-all;"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 font-weight-bold">
                                <span>UTM information</span>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="row">
                                    <div class="col-md-6">UTM source :</div>
                                    <div class="col-md-6">
                                        <span>{{ typeof user.utm != 'undefined' ? user.utm['utm_source'] : '-' }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">UTM medium :</div>
                                    <div class="col-md-6">
                                        <span>{{ typeof user.utm != 'undefined' ? user.utm['utm_medium'] : '-' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-4">
                                <div class="row">
                                    <div class="col-md-6">UTM campaign :</div>
                                    <div class="col-md-6">
                                        <span>{{
                                            typeof user.utm != 'undefined' ? user.utm['utm_campaign'] : '-'
                                        }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">UTM id :</div>
                                    <div class="col-md-6">
                                        <span>{{ typeof user.utm != 'undefined' ? user.utm['utm_id'] : '-' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12 font-weight-bold">
                                        <span>Playing statistics</span>
                                    </div>
                                    <div class="col-md-6">Play Live :</div>
                                    <div class="col-md-6">
                                        <span>{{ user.play_together ? user.play_together : 0 }}</span>
                                    </div>
                                    <div class="col-md-6">Played Alone :</div>
                                    <div class="col-md-6">
                                        <span>{{ user.play_alone ? user.play_alone : 0 }}</span>
                                    </div>
                                    <div class="col-md-12">Played with users :</div>
                                    <div class="col-md-12">
                                        <div class="pill-container">
                                            <span v-if="!user.user_detail.played_with_users.length">-</span>
                                            <div
                                                v-for="(join, index) in user.user_detail.played_with_users"
                                                :key="index"
                                                class="pill-item"
                                            >
                                                {{ join.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">Last played :</div>
                                    <div class="col-md-6">
                                        <span>{{ user.last_play ? user.last_play_readable : '-' }}</span>
                                    </div>
                                    <div class="col-md-12">Last 5 played :</div>
                                    <div class="col-md-12">
                                        <div class="pill-container">
                                            <span v-if="!user.user_detail.last_quiz_play.length">-</span>
                                            <div
                                                v-for="(quiz, index) in user.user_detail.last_quiz_play"
                                                :key="index"
                                                class="pill-item"
                                            >
                                                {{ quiz.title }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">Categories :</div>
                                    <div class="col-md-6">
                                        <span v-if="!user.user_detail.categories.length">-</span>
                                        <div
                                            v-for="(item, index) in user.user_detail.categories"
                                            :key="index"
                                            class="pill-item"
                                        >
                                            {{ item.category.name }} : {{ item.score.length }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12 font-weight-bold">
                                        <span>Order history</span>
                                    </div>
                                    <div class="col-md-12">
                                        <span>Active Orders : </span>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        <span v-if="!user.user_detail.orders.length">-</span>
                                        <div
                                            v-for="(order, index) in user.user_detail.orders"
                                            :key="index"
                                            class="pill-item"
                                        >
                                            <span v-if="order.is_active">- {{ order.plan_name }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <span>Historical orders : </span>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        <span v-if="!user.user_detail.orders.length">-</span>
                                        <div
                                            v-for="(order, index) in user.user_detail.orders"
                                            :key="index"
                                            class="pill-item"
                                        >
                                            <span v-if="!order.is_active">- {{ order.plan_name }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        Newsletter :&nbsp;
                                        <span>{{ user.send_me_news ? 'Yes' : 'No' }}</span>
                                    </div>
                                    <div class="col-md-12 mb-4">
                                        <a
                                            @click.prevent="filterByUser(user._id.$oid)"
                                            href="javascript:void(0)"
                                            class="cursor-pointer"
                                        >
                                            See/manage all orders
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex justify-content-end w-100">
                            <div class="w-100">
                                <router-link
                                    v-if="
                                        ['contributor', 'creator', 'admin', 'super_admin', 'premium_user'].indexOf(
                                            user.role.toLowerCase()
                                        ) > -1
                                    "
                                    data-dismiss="modal"
                                    tags="a"
                                    :to="{
                                        name: 'user.payout',
                                        params: {
                                            id: user._id.$oid
                                        }
                                    }"
                                >
                                    <button class="btn btn-warning mr-2">Edit Payout</button>
                                </router-link>
                            </div>
                            <div class="w-100 text-right">
                                <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">Close</button>
                                <router-link
                                    data-dismiss="modal"
                                    tags="a"
                                    :to="{
                                        name: 'user.edit',
                                        params: {
                                            id: user._id.$oid
                                        }
                                    }"
                                >
                                    <button class="btn btn-success">Edit User</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UserIcon } from 'vue-feather-icons'
import Loader from '@/components/Loader.vue'
import helper from '../../service/helpers.js'
import Url from '@/service/url'
import jQuery from 'jquery'

export default {
    name: 'form-modal',

    props: {
        id: {
            type: String,
            default: ''
        },
        user: {
            type: Object,
            default: null
        }
    },

    components: {
        UserIcon,
        Loader
    },

    data() {
        return {
            isOpen: false,
            form: {},
            detailBoards: null
        }
    },

    watch: {
        user: {
            immediate: true,
            handler() {
                if (this.user && !this.user.loading) {
                    this.initDetailBoards()
                }
            }
        }
    },

    methods: {
        initDetailBoards() {
            this.detailBoards = {
                details: [{
                        title: 'Quizzes',
                        value: this.user.user_detail.all_quiz_count,
                        condition: true
                    }, {
                        title: 'Play Game',
                        value: this.calculatPlayTime(this.user),
                        condition: true
                    }, {
                        title: 'Credits',
                        value: this.user.credit ? parseFloat(this.user.credit.toFixed(2)) : 0,
                        condition: true
                    }, {
                        title: 'AI questions',
                        value: this.user.ai_question.limit,
                        condition: true
                    }, {
                        title: 'Affiliate user',
                        value: this.user.user_detail.partner_user_count,
                        condition: this.user.role_label == 'Partner'
                    }
                ],
                orders: [{
                        title: 'Orders',
                        value: this.user.user_detail.order_count,
                        condition: true
                    }, {
                        title: 'Total order value',
                        value: this.user.total_order_value + '$',
                        condition: true
                    }
                ]
            }
        },

        convertDate(date) {
            return helper.convertDateFormat(parseInt(date))
        },

        calculatPlayTime(user) {
            const playAlone = user.play_alone ? user.play_alone : 0,
                playTogether = user.play_together ? user.play_together : 0

            return playAlone + playTogether
        },

        displayReferrer(refData) {
            if (!refData) {
                return '-'
            }

            switch (refData.type) {
                case 'site':
                    return `<strong>[Site]</strong> <i>${refData.data.ref_url}</i>`
                case 'direct':
                    return `<strong>[Direct]</strong> <i>${refData.data.ref_url}</i>`
                case 'search_engine':
                    return `<strong>[Search Engine]</strong> <i>${refData.data.ref_url}</i>`
                case 'campaign':
                    var messages = [`<strong>[Campaign]</strong><br/>`]

                    if (refData.data.ref_url) {
                        messages.push(`- Referrer Site <i>${refData.data.ref_url}</i><br/>`)
                    }

                    if (refData.data.utm_source) {
                        messages.push(`- UTM Source: <i>${refData.data.utm_source}</i><br/>`)
                    }

                    if (refData.data.utm_medium) {
                        messages.push(`- UTM Medium: <i>${refData.data.utm_medium}</i><br/>`)
                    }

                    if (refData.data.utm_campaign) {
                        messages.push(`- UTM Campaign: <i>${refData.data.utm_campaign}</i>`)
                    }

                    return messages.join('')
                default:
                    return ''
            }
        },

        filterByUser(userId) {
            const url = new Url()
            const query = url.getQuery()

            if (query.user_id == userId) {
                return
            }

            jQuery(this.$refs.modal).modal('hide')

            this.$router.push({
                name: 'user.order-list',
                params: {
                    id: userId
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

$color: $color-primary;

.icon-image-border {
    max-width: 40px;
    max-height: 40px;
    width: 100%;
    height: 100vh;
    border: 1px solid white;
    border-radius: 50%;
    text-align: center;
    overflow: hidden;
}

.pill-container {
    display: flex;
    flex-wrap: wrap;

    .pill-item {
        cursor: default;
        display: inline;
        border: 1px solid transparent;
        border-radius: 3px;
        color: #dc3545;
        background-color: rgba(220, 53, 69, 0.1);
        padding: 0.15rem 0.5rem;
        margin: 3px 5px;
    }
}

.collapse-container {
    .collapse-title {
        .icon {
            position: absolute;
            margin: 0.15rem 0 0 0.5rem;
            transform: scale(0);
            filter: drop-shadow(0px 0px 6px #dc3545);
            transition: transform 0.5s;

            &.active {
                transform: scale(1);
            }
        }
    }
}
</style>
